<template>
  <vxe-modal ref="modal" v-model="formVisible" title="审批" :width="isMobile ? '80%' : '400px'">
    <el-form ref="FormRef" :size="isMobile ? 'medium' : 'mini'" :model="form" :rules="rules">
      <el-form-item label="审批报价(元)" prop="final_quotation">
        <el-input placeholder="输入" v-model="form.final_quotation" v-money:2="showMoney" />
      </el-form-item>
      <el-form-item label="审批意见">
        <el-input type="textarea" placeholder="输入" :rows="5" v-model="ApprovalOpinions" />
      </el-form-item>
    </el-form>

    <div style="display: flex;justify-content: flex-end" v-if="!isMobile">
      <el-button @click="closeModal()">取消</el-button>
      <el-button type="primary" @click="confirm()">确认</el-button>
    </div>

    <div style="width: 100%" v-else>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-button style="width: 100%" @click="closeModal()">取消</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" style="width: 100%" @click="confirm()">确认</el-button>
        </el-col>
      </el-row>
    </div>
  </vxe-modal>
</template>
<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formVisible: false,
      form: {
        final_quotation: 0
      },
      ApprovalOpinions: '',
      showMoney: true,
      rules: {
        final_quotation: [
          { required: true, message: '请输入最终报价(元)', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 12,
            decimalLength: 2,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    openModal(amount = 0) {
      this.form.final_quotation = amount
      this.ApprovalOpinions = ''

      this.formVisible = true
    },
    closeModal() {
      this.formVisible = false
    },
    async confirm() {
      const that = this
      let flag = true
      await that.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )

      if (!flag) {
        that.$message.error('验证失败,请核对输入数据')
      } else {
        this.$emit('sureBack', { final_quotation: this.form.final_quotation, ApprovalOpinions: this.ApprovalOpinions })
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
